// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height'>
const SvgDrug = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g clipPath="url(#drug_svg__a)">
      <path
        fill={props.color ?? 'currentColor'}
        d="M7.671 8 5.775 6.104l-.793-.793-2.968 2.968a3.804 3.804 0 0 0 0 5.378 3.804 3.804 0 0 0 5.378 0l2.968-2.968-.844-.844zm.279-5.657L4.982 5.311l.793.793a531 531 0 0 0 2.968-2.967c.92-.92 2.566-1.314 3.835-.044 1.142 1.141.84 2.879-.08 3.798 0 0-1.921 1.893-2.982 2.954l.844.844 2.968-2.968a3.804 3.804 0 0 0 0-5.378 3.804 3.804 0 0 0-5.378 0"
      />
    </g>
    <defs>
      <clipPath id="drug_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgDrug
